// packages/common/src/sse/useSSE.ts
import { useEffect } from 'react';
import { sseManager, type Handler } from './SSEManager';

/**
 * Subscribe to a single SSE event type via the shared SSEManager.
 *
 * The connection opens on first subscriber and closes when the last
 * subscriber unsubscribes.
 *
 * `handler` MUST be referentially stable — wrap in `useCallback` at the
 * call site. It is intentionally excluded from effect deps to prevent
 * reconnect storms when parent re-renders.
 */
export function useSSE<T extends Record<string, unknown>>(
  eventType: string,
  enabled: boolean,
  handler: (payload: T) => void,
): void {
  useEffect(() => {
    if (!enabled) return;
    return sseManager.subscribe(eventType, handler as Handler);
    // handler intentionally excluded from deps — must be stable at call site
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventType, enabled]);
}
